import {
  checking,
  inHouse,
  inventoryDetails,
  outOfStock,
  warehouseConfig,
  Workbench,
  report,
  assemble,
} from "@/router/routes";

const menus = [
  {
    name: "工作台",
    openPath: "/workbench",
    pages: Workbench,
  },
  {
    name: "入库",
    openPath: "/inHouse_receipt",
    pages: inHouse,
  },
  {
    name: "检品",
    openPath: "/checking_washingLabelRequire",
    pages: checking,
  },
  {
    name: "组合",
    openPath: "/assemble",
    pages: assemble,
  },
  // {
  //     name: '异常',
  //     openPath: '/abnormal/...',
  //     pages: abnormal
  // },
  {
    name: "出库",
    openPath: "/outOfStock_internationalShipment",
    pages: outOfStock,
  },
  {
    name: "库存详情",
    openPath: "/inventoryDetails_warehouseStatus",
    pages: inventoryDetails,
  },
  {
    name: "报表",
    openPath: "/report",
    pages: report,
  },
  {
    name: "配置",
    openPath: "/configure_box",
    pages: warehouseConfig,
  },
];
export default menus;
